/**
 * SummaryHeaderNav.jsx — 요약 헤더(제목 + 연/월 네비게이션)
 *
 * TmSummary.jsx 에서 분리(300줄 규칙). 렌더 결과·동작은 분리 전과 동일합니다.
 * lockedMonth=true 면 월 이동 없이 고정 월 배지만 표시합니다(관리자 모달·정산서 모드).
 */
import React from 'react';
import { NAV_BTN, NAV_SELECT } from './utils';

export default function SummaryHeaderNav({
  title,
  isMobile,
  lockedMonth,
  year,
  month,
  baseYear,           // 연도 select 목록 기준 연도(현재 연도)
  onPrev,
  onNext,
  onToday,
  onYearChange,       // (number) => void
  onMonthChange,      // (number) => void
}) {
  const fixedMonthBadgeStyle = {
    ...NAV_SELECT,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: isMobile ? 96 : 112,
    fontWeight: 900,
    color: 'var(--text)',
    pointerEvents: 'none',
  };
  const fixedMonthLabel = `${year}년 ${month}월`;

  const yearSelect = (
    <select value={year} onChange={(e) => onYearChange(Number(e.target.value))} style={NAV_SELECT}>
      {Array.from({ length: 5 }, (_, i) => baseYear - 3 + i).map((y) => (
        <option key={y} value={y}>{y}년</option>
      ))}
    </select>
  );
  const monthSelect = (
    <select value={month} onChange={(e) => onMonthChange(Number(e.target.value))} style={NAV_SELECT}>
      {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
        <option key={m} value={m}>{m}월</option>
      ))}
    </select>
  );

  // 모바일: 2행 / 데스크탑: 1행
  if (isMobile) {
    return (
      <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 900, color: 'var(--text)' }}>{title}</h2>
          {lockedMonth ? (
            <span style={fixedMonthBadgeStyle}>{fixedMonthLabel}</span>
          ) : (
            <button onClick={onToday} style={{ ...NAV_BTN, fontSize: 12, color: 'var(--text-muted)', border: '1px solid var(--border)' }}>오늘</button>
          )}
        </div>
        {!lockedMonth && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <button onClick={onPrev} style={NAV_BTN}>‹</button>
            {yearSelect}
            {monthSelect}
            <button onClick={onNext} style={NAV_BTN}>›</button>
          </div>
        )}
      </>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 900, color: 'var(--text)' }}>{title}</h2>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {lockedMonth ? (
          <span style={fixedMonthBadgeStyle}>{fixedMonthLabel}</span>
        ) : (
          <>
            <button onClick={onPrev} style={NAV_BTN}>‹</button>
            {yearSelect}
            {monthSelect}
            <button onClick={onNext} style={NAV_BTN}>›</button>
            <button onClick={onToday} style={{ ...NAV_BTN, fontSize: 12, color: 'var(--text-muted)' }}>오늘</button>
          </>
        )}
      </div>
    </div>
  );
}
